module.exports = __webpack_public_path__ + "static/media/gryphon_musee_urbanlandscape_3.adf91c47.jpg";